import {ListItemViewModel} from "../../../infrastructure/models/list-item.view-model";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";


export class AthleteTabViewModel extends ListItemViewModel {
  analyticsName: String;

  constructor(index: Number, name: String , active: Boolean, visible: Boolean, linkModel: BaseLinkModel, analyticsName: String) {
    linkModel.replace = true;

    super({index, name, active: false, visible, linkModel});
    this.analyticsName = analyticsName;
  }

}
